import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-engage-gray1 border-t border-engage-gray2 pt-16 pb-8" data-id="element-106" data-mp="ep296pq04agt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107" data-mp="aldyvz9zj0rv">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-108" data-mp="5n2q7rvfewb8">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-109" data-mp="5pf2ppif0egw">
            <Link to="/" className="flex items-center mb-4" data-id="element-110" data-mp="pu7nq6d8q9g">
              <img src="https://cdn.magicpatterns.com/uploads/rubaJbsbfYXRnY6rEG65oJ/Logo_Engage_Media_white.png" alt="Engage Media" className="h-16 w-auto" data-id="element-111" data-mp="3s1vl8ljk36aq" />
            </Link>
            <p className="text-engage-gray4 max-w-xs mx-auto md:mx-0" data-id="element-112" data-mp="3j2s0ld4qqiu4">
              A performance growth agency building systems that move people,
              drive action, and generate real revenue.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col space-y-3 items-center md:items-start text-center md:text-left" data-id="element-113" data-mp="3965gwro5hxto">
            <h4 className="text-engage-white font-semibold mb-2" data-id="element-114" data-mp="2p3tda65y899v">Navigation</h4>
            <Link to="/" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-115" data-mp="2p5xqxftngmnc">
              Home
            </Link>
            <Link to="/services" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-116" data-mp="2gckrrw4zsost">
              Services
            </Link>
            <Link to="/case-studies" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-117" data-mp="382fh3ssuoehh">
              Case Studies
            </Link>
            <Link to="/contact" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-118" data-mp="2u5aczycp5pov">
              Contact
            </Link>
            <Link to="/careers" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-119" data-mp="1im69dzq4f9kj">
              Careers
            </Link>
          </div>

          {/* Contact & Social */}
          <div className="flex flex-col space-y-4 items-center md:items-start text-center md:text-left" data-id="element-120" data-mp="13mu1i67en53m">
            <h4 className="text-engage-white font-semibold mb-2" data-id="element-121" data-mp="zl8qkqefl0w2">Connect</h4>
            <a href="mailto:contact@engagemedia.group" className="flex items-center justify-center md:justify-start text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-122" data-mp="uquusmvuwrqv">
              <Mail size={18} className="mr-2" data-id="element-123" data-mp="kvaxbw1n9l00" />
              contact@engagemedia.group
            </a>
            <a href="https://instagram.com/engagemedia.us" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-124" data-mp="fudk7xvhrh5d">
              <Instagram size={18} className="mr-2" data-id="element-125" data-mp="6wbe53wwhyb8" />
              @engagemedia.us
            </a>
          </div>
        </div>

        <div className="border-t border-engage-gray2 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-engage-gray5 text-center md:text-left" data-id="element-126" data-mp="218hvylkavdci">
          <p data-id="element-127" data-mp="28rqypvyawdsl">© 2026 Engage Media. All rights reserved.</p>
          <div className="mt-4 md:mt-0 space-x-4" data-id="element-128" data-mp="2dqbwloq2yldv">
            <Link to="#" className="hover:text-engage-white transition-colors" data-id="element-129" data-mp="2dp0xi27ky1t3">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-engage-white transition-colors" data-id="element-130" data-mp="2ngndscyryr2p">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}